import { api } from '@/lib/api/client'

/**
 * Baixa o blob da foto do número WhatsApp do tenant (1 phone/tenant — sem phone_id na URL).
 *
 * `cacheBust` (tenant_id) entra como query param `t` pra deixar a URL única por tenant. Sem isso a URL é
 * IDÊNTICA pra todos (`/whatsapp/profile/picture`; o tenant vem só do JWT no header Authorization, que NÃO
 * faz parte da chave de cache HTTP do browser), então o cache do browser serve a foto do PRIMEIRO tenant
 * acessado pra todos os tenants seguintes — mesmo com a queryKey do TanStack já escopada por tenant, porque
 * esse cache vive numa camada abaixo do axios/React Query e sobrevive à troca de tenant (login é SPA nav,
 * não recarrega a página). Um param diferente por tenant impede a reutilização indevida do blob cacheado.
 */
export async function fetchProfilePictureBlob(cacheBust?: string): Promise<Blob> {
  const { data } = await api.get<Blob>('/whatsapp/profile/picture', {
    responseType: 'blob',
    params: cacheBust ? { t: cacheBust } : undefined,
  })
  return data
}
